import { Modal, Button } from "react-bootstrap";

function PolicyTermsModal({ show, policy, handleOk }) {
  return (
    <Modal className="static-modal" show={show}>
      <Modal.Header>
        <Modal.Title>IMPORTANT NOTE</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <span>{policy}</span>
      </Modal.Body>

      <Modal.Footer>
        <Button bsStyle="primary" onClick={handleOk}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PolicyTermsModal;
